import React, {useState, useEffect} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputText from '../FormFields/InputText';
import SelectInfinite from '../FormFields/SelectInfinite';
import TextArea from '../FormFields/Textarea';
import InputDate from '../FormFields/inputDate/InputDate';
import {useForm, FormProvider} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import {getLanguage, t} from 'react-switch-lang';
import * as yup from 'yup';
import ModalHistory from '../../app/Measures/components/ShowHistoryModal';
import ModalVerify from '../../app/Measures/components/VerifyModal';
import {
    updateMeasure, getMeasureFile,
} from '../../services/measuresService/measuresApi';
import {getAllUsers} from '../../services/usersService';
import {validDouble} from '../../utils/const';
import {format} from 'date-fns';
import Toast from '../toast/Toast';
import Trash from '../../app/Measures/img/Trash.svg';
import SelectList from '../../components/FormFields/select/SelectList';
import DownloadOutlined from '@ant-design/icons/lib/icons/DownloadOutlined';
import allowedFileTypes from '../../utils/allowedFileTypes';
import PreventTransitionPrompt from '../preventTransitionprompt/PreventTransition';

function MeasuresFromShow({
                              data,
                              toggleOpen,
                              open,
                              userData,
                              userResponsibleRisk,
                              userInCharge,
                              riskId,
                              estimatedGrossLost,
                              allowEdit,
                          }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalVerifyOpen, setIsModalVerifyOpen] = useState(false);
    const [disabled, setDisabled] = useState(true);
    const [id, setId] = useState(data.id);
    const [files, setFiles] = useState([]);
    const [deleteFiles, setDeleteFiles] = useState([]);
    const [defaultFiles, setDefaultFiles] = useState(data?.files);
    const [disableBtn, setDisableBtn] = useState(false);

    const [users, setUsers] = useState([]);
    const fetchUsers = async () => {
        try {
            const {data} = await getAllUsers();
            setUsers(data);
            return data;
        } catch (e) {
        }
    };

    useEffect(() => {
        fetchUsers().then((r) => {
            let usersMap = [];
            r.forEach((item) => {
                usersMap.push({
                    value: item.id, label: item.firstName + ' ' + item.lastName,
                });
            });
            setUsers(usersMap);
            // setLoading(false);
        });
    }, []);
    const lang = getLanguage();

    const [schema, setScheme] = useState(yup.object().shape({
        realizationDate: yup
            .string()
            .nullable()
            .trim()
            .required(t('message.fieldRequired')),
        riskAnalysis: yup
            .string()
            .trim()
            .required(t('message.fieldRequired'))
            .max(2000, t('message.max', {max: 2000})),
        levelOfMeasureRealization: yup
            .object()
            .nullable()
            .required(t('message.fieldRequired')),
        cost: yup.object().nullable().required(t('message.fieldRequired')),
        department: yup.object().nullable().required(t('message.fieldRequired')),
        grossLoss: yup
            .string()
            .trim()
            .matches(validDouble, t('message.onlyDecimalNumbers'))
            .typeError(t('message.onlyDecimalNumbers')),
        lossChargedInsurance: yup
            .string()
            .trim()
            .matches(validDouble, t('message.onlyDecimalNumbers'))
            .typeError(t('message.onlyDecimalNumbers')),
        lossChargedOther: yup
            .string()
            .trim()
            .matches(validDouble, t('message.onlyDecimalNumbers'))
            .typeError(t('message.onlyDecimalNumbers')),
        netLoss: yup
            .string()
            .trim()
            .matches(validDouble, t('message.onlyDecimalNumbers'))
            .typeError(t('message.onlyDecimalNumbers')),
        mitigationMeasures: yup
            .string()
            .trim()
            .required(t('message.fieldRequired'))
            .max(2000, t('message.max', {max: 2000})),
        hdRequestId: yup.string().trim(),
        mitigationPercentage: yup
            .string()
            .trim()
            .matches(validDouble, t('message.onlyDecimalNumbers'))
            .typeError(t('message.onlyDecimalNumbers')),
        additionalMitigationMeasures: yup
            .string()
            .trim()
            .max(2000, t('message.max', {max: 2000})),
    }));

    const optionsTask = [{value: 'NOTSTARTED', label: `${t('mitigation-measures.notStarted')}`}, {
        value: 'INPROGRESS',
        label: `${t('mitigation-measures.inProgress')}`
    }, {value: 'REALIZED', label: `${t('mitigation-measures.realized')}`},];

    const toggleShowModal = (e) => {
        e && e.preventDefault();
        setIsModalOpen(!isModalOpen);
    };

    const setEdit = (e) => {
        e && e.preventDefault();
        setDisabled(false);
    };

    const toggleVerifyModal = (e) => {
        e && e.preventDefault();
        setIsModalVerifyOpen(!isModalVerifyOpen);
    };

    const submitForm = async (submitedData) => {
        setDisableBtn(true);
        const files = document.getElementById('upload').files;
        const dateFormated = format(new Date(submitedData.realizationDate), 'yyyy-MM-dd') + 'T' + format(new Date(submitedData.realizationDate), 'hh:mm:ss');

        const payload = {
            id: id,
            mitigationMeasures: submitedData.mitigationMeasures,
            costEstimationId: submitedData.cost.value,
            departmentInChargeId: submitedData.department.value,
            grossLoss: parseFloat(watch('grossLoss')),
            lossChargedInsurance: parseFloat(submitedData.lossChargedInsurance),
            lossChargedOther: parseFloat(submitedData.lossChargedOther),
            levelOfMeasureRealization: submitedData.levelOfMeasureRealization.value,
            hdRequestId: submitedData.hdRequestId,
            mitigationPercentage: parseFloat(submitedData.mitigationPercentage),
            netLoss: parseFloat(watch('netLoss')),
            riskAnalysis: submitedData.riskAnalysis,
            realizationDate: dateFormated,
            notStartedReason: submitedData.notStartedReason,
            userResponsibleId: submitedData.userResponsibleId.value,
            riskId: riskId,
            userCreatedId: userData.id,
            appliedMeasureResult: {name: submitedData.resultOfApplied},
            deleteFiles: deleteFiles,
            additionalMitigationMeasures: submitedData.additionalMitigationMeasures,
            measureStatus: data.measureStatus,
        };
        try {
            const response = await updateMeasure(payload, files);
            if (response.status === 200) {
                await Toast.fire({
                    title: t('message.updateSuccess3', {entity: t('common.measure')}), icon: 'success',
                });
            }
            // toggleOpen(!open);
            setDisabled(true);
            await window.location.reload();
            setDisableBtn(false);
        } catch (err) {
            // console.log(err, 'error');
            if (err.response.status === 400) {
                await Toast.fire({
                    title: t('message.errorApi'), icon: 'error',
                });
            }
            if (err.response.code === 'file-format') {
                await Toast.fire({
                    title: t('message.fileFormatNotAllowed'), icon: 'error',
                });
            }
            toggleOpen(!open);
            setDisableBtn(false);
        }
    };

    const handleCancel = (e) => {
        e.preventDefault();
        toggleOpen(!open);
        setDisabled(true);
    };

    useEffect(() => {
        if (disabled === false) {
            setDisabled(true);
        }
    }, [open]);

    const methods = useForm({
        resolver: yupResolver(schema),
    });

    const {handleSubmit, watch, setValue} = methods;
    const wathcLevelOfRealization = watch('levelOfMeasureRealization');

    useEffect(() => {
        if (wathcLevelOfRealization?.value) {
            if (wathcLevelOfRealization?.value === 'NOTSTARTED') {
                setScheme(yup.object().shape({
                    realizationDate: yup
                        .string()
                        .nullable()
                        .trim()
                        .required(t('message.fieldRequired')),
                    riskAnalysis: yup
                        .string()
                        .trim()
                        .required(t('message.fieldRequired'))
                        .max(2000, t('message.max', {max: 2000})),
                    levelOfMeasureRealization: yup
                        .object()
                        .nullable()
                        .required(t('message.fieldRequired')),
                    cost: yup.object().nullable().required(t('message.fieldRequired')),
                    department: yup
                        .object()
                        .nullable()
                        .required(t('message.fieldRequired')),
                    notStartedReason: yup
                        .string()
                        .trim()
                        .required(t('message.fieldRequired'))
                        .max(1000, t('message.max', {max: 1000})),
                    grossLoss: yup
                        .string()
                        .trim()
                        .matches(validDouble, t('message.onlyDecimalNumbers'))
                        .typeError(t('message.onlyDecimalNumbers')),
                    lossChargedInsurance: yup
                        .string()
                        .trim()
                        .matches(validDouble, t('message.onlyDecimalNumbers'))
                        .typeError(t('message.onlyDecimalNumbers')),
                    lossChargedOther: yup
                        .string()
                        .trim()
                        .matches(validDouble, t('message.onlyDecimalNumbers'))
                        .typeError(t('message.onlyDecimalNumbers')),
                    netLoss: yup
                        .string()
                        .trim()
                        .matches(validDouble, t('message.onlyDecimalNumbers'))
                        .typeError(t('message.onlyDecimalNumbers')),
                    mitigationMeasures: yup
                        .string()
                        .trim()
                        .required(t('message.fieldRequired'))
                        .max(2000, t('message.max', {max: 2000})),
                    hdRequestId: yup.string().trim(),
                    mitigationPercentage: yup
                        .string()
                        .trim()
                        .matches(validDouble, t('message.onlyDecimalNumbers'))
                        .typeError(t('message.onlyDecimalNumbers')),
                    additionalMitigationMeasures: yup
                        .string()
                        .trim()
                        .max(2000, t('message.max', {max: 2000})),
                    resultOfApplied: yup
                        .string()
                        .trim()
                        .max(1000, t('message.max', {max: 1000})),
                }));
            } else if (wathcLevelOfRealization?.value === 'INPROGRESS') {
                setScheme(yup.object().shape({
                    realizationDate: yup
                        .string()
                        .nullable()
                        .trim()
                        .required(t('message.fieldRequired')),
                    riskAnalysis: yup
                        .string()
                        .trim()
                        .required(t('message.fieldRequired'))
                        .max(2000, t('message.max', {max: 2000})),
                    levelOfMeasureRealization: yup
                        .object()
                        .nullable()
                        .required(t('message.fieldRequired')),
                    cost: yup.object().nullable().required(t('message.fieldRequired')),
                    department: yup
                        .object()
                        .nullable()
                        .required(t('message.fieldRequired')),
                    resultOfApplied: yup
                        .string()
                        .trim()
                        .required(t('message.fieldRequired'))
                        .max(1000, t('message.max', {max: 1000})),
                    grossLoss: yup
                        .string()
                        .trim()
                        .matches(validDouble, t('message.onlyDecimalNumbers'))
                        .typeError(t('message.onlyDecimalNumbers')),
                    lossChargedInsurance: yup
                        .string()
                        .trim()
                        .matches(validDouble, t('message.onlyDecimalNumbers'))
                        .typeError(t('message.onlyDecimalNumbers')),
                    lossChargedOther: yup
                        .string()
                        .trim()
                        .matches(validDouble, t('message.onlyDecimalNumbers'))
                        .typeError(t('message.onlyDecimalNumbers')),
                    netLoss: yup
                        .string()
                        .trim()
                        .matches(validDouble, t('message.onlyDecimalNumbers'))
                        .typeError(t('message.onlyDecimalNumbers')),
                    mitigationMeasures: yup
                        .string()
                        .trim()
                        .required(t('message.fieldRequired'))
                        .max(2000, t('message.max', {max: 2000})),
                    hdRequestId: yup.string().trim(),
                    mitigationPercentage: yup
                        .string()
                        .trim()
                        .matches(validDouble, t('message.onlyDecimalNumbers'))
                        .typeError(t('message.onlyDecimalNumbers')),
                    additionalMitigationMeasures: yup
                        .string()
                        .trim()
                        .max(2000, t('message.max', {max: 2000})),
                    notStartedReason: yup
                        .string()
                        .trim()
                        .max(1000, t('message.max', {max: 1000})),
                }));
            } else {
                setScheme(yup.object().shape({
                    realizationDate: yup
                        .string()
                        .nullable()
                        .trim()
                        .required(t('message.fieldRequired')),
                    riskAnalysis: yup
                        .string()
                        .trim()
                        .required(t('message.fieldRequired'))
                        .max(2000, t('message.max', {max: 2000})),
                    levelOfMeasureRealization: yup
                        .object()
                        .nullable()
                        .required(t('message.fieldRequired')),
                    cost: yup.object().nullable().required(t('message.fieldRequired')),
                    department: yup
                        .object()
                        .nullable()
                        .required(t('message.fieldRequired')),
                    resultOfApplied: yup
                        .string()
                        .trim()
                        .required(t('message.fieldRequired'))
                        .max(1000, t('message.max', {max: 1000})),
                    grossLoss: yup
                        .string()
                        .trim()
                        .matches(validDouble, t('message.onlyDecimalNumbers'))
                        .typeError(t('message.onlyDecimalNumbers')),
                    lossChargedInsurance: yup
                        .string()
                        .trim()
                        .matches(validDouble, t('message.onlyDecimalNumbers'))
                        .typeError(t('message.onlyDecimalNumbers')),
                    lossChargedOther: yup
                        .string()
                        .trim()
                        .matches(validDouble, t('message.onlyDecimalNumbers'))
                        .typeError(t('message.onlyDecimalNumbers')),
                    netLoss: yup
                        .string()
                        .trim()
                        .matches(validDouble, t('message.onlyDecimalNumbers'))
                        .typeError(t('message.onlyDecimalNumbers')),
                    mitigationMeasures: yup
                        .string()
                        .trim()
                        .required(t('message.fieldRequired'))
                        .max(2000, t('message.max', {max: 2000})),
                    hdRequestId: yup.string().trim(),
                    mitigationPercentage: yup
                        .string()
                        .trim()
                        .matches(validDouble, t('message.onlyDecimalNumbers'))
                        .typeError(t('message.onlyDecimalNumbers')),
                    additionalMitigationMeasures: yup
                        .string()
                        .trim()
                        .max(2000, t('message.max', {max: 2000})),
                    notStartedReason: yup
                        .string()
                        .trim()
                        .max(1000, t('message.max', {max: 1000})),
                }));
            }
        }
    }, [wathcLevelOfRealization]);

    const uploadOnChange = () => {
        const input = document.getElementById('upload');
        let children = [];
        if (input.files.length > 10) {
            Toast.fire({
                title: t('message.tooManyFiles'), icon: 'error',
            });
        } else {
            for (let i = 0; i < input.files.length; ++i) {
                if (input.files.item(i).size > 10485760) {
                    Toast.fire({
                        title: t('message.fileTooBig'), icon: 'error',
                    });
                } else {
                    children.push({
                        id: input.files.item(i).name, label: input.files.item(i).name,
                    });
                    setFiles(children);
                }
            }
        }
    };

    const clearFetchedFile = (id) => {
        let children = defaultFiles.filter((file) => file.id !== id);
        let deleteFilesIds = [];
        deleteFilesIds.push(id);
        setDefaultFiles([...children]);
        setDeleteFiles(deleteFilesIds);
    };

    const clearLocalFile = (index) => {
        const dt = new DataTransfer();
        const input = document.getElementById('upload');
        const {files} = input;
        let children = [];
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            if (index !== i) {
                dt.items.add(file); // here you exclude the file
                children.push({
                    id: input.files.item(i).name, label: input.files.item(i).name,
                });
            }
        }
        input.files = dt.files;
        setFiles(children);
    };

    const onChangeGrossLoss = (e) => {
        let result = '';
        let valueNoText = e.target.value.replace(/[^0-9.]/, '');
        let valueDouble = valueNoText.match(/^(\d+(?:(.|,)\d{1,2})?).*/);
        if (valueDouble !== undefined && valueDouble !== null) {
            result = valueDouble[1];
        }
        setValue('grossLoss', result);
    };

    const onChangeLossChargedInsurance = (e) => {
        let result = '';
        let valueNoText = e.target.value.replace(/[^0-9.]/, '');
        let valueDouble = valueNoText.match(/^(\d+(?:(.|,)\d{1,2})?).*/);
        if (valueDouble !== undefined && valueDouble !== null) {
            result = valueDouble[1];
        }
        setValue('lossChargedInsurance', result);
    };

    const onChangeLossChargedOther = (e) => {
        let result = '';
        let valueNoText = e.target.value.replace(/[^0-9.]/, '');
        let valueDouble = valueNoText.match(/^(\d+(?:(.|,)\d{1,2})?).*/);
        if (valueDouble !== undefined && valueDouble !== null) {
            result = valueDouble[1];
        }
        setValue('lossChargedOther', result);
    };

    const onChangeMitigationPercentage = (e) => {
        let result = '';
        let valueNoText = e.target.value.replace(/[^0-9.]/, '');
        let valueDouble = valueNoText.match(/^(\d+(?:(.|,)\d{1,2})?).*/);
        if (valueDouble !== undefined && valueDouble !== null) {
            result = valueDouble[1];
        }
        setValue('mitigationPercentage', result);
    };

    const onChangeNetLoss = (e) => {
        let result = '';
        let valueNoText = e.target.value.replace(/[^0-9.]/, '');
        let valueDouble = valueNoText.match(/^(\d+(?:(.|,)\d{1,2})?).*/);
        if (valueDouble !== undefined && valueDouble !== null) {
            result = valueDouble[1];
        }
        setValue('netLoss', result);
    };

    const watchLossChargedInsurance = watch('lossChargedInsurance');
    const watchLossChargedOther = watch('lossChargedOther');
    const watchEstimatedGrossLost = watch('grossLoss');
    useEffect(() => {
        if (watchLossChargedInsurance && watchLossChargedOther) {
            let no = parseFloat(watchEstimatedGrossLost) - parseFloat(watchLossChargedInsurance) - parseFloat(watchLossChargedOther);
            setValue('netLoss', no.toFixed(2));
        }
    }, [watchLossChargedInsurance, watchLossChargedOther]);

    return (<>
            <PreventTransitionPrompt when={!disabled}/>
            <FormProvider {...methods}>
                <form onSubmit={handleSubmit(submitForm)}>
                    <Row className="mb-5 main-form">
                        <Col xs={6} md={6} lg={3}>
                            <label className="label-measures">
                                {t('mitigation-measures.person')}
                            </label>
                            <SelectList
                                name="userResponsibleId"
                                className="select"
                                options={users}
                                defaultValue={{
                                    value: data.userResponsibleId,
                                    label: data.userResponsibleFirstName + ' ' + data.userResponsibleLastName,
                                }}
                                placeholder={t('placeholder.userResponsibleId')}
                                isClearable={false}
                                isDisabled={true}
                            />
                            <label className="label-measures">
                                {t('mitigation-measures.analysis')}
                            </label>
                            <TextArea
                                name="riskAnalysis"
                                className={`form-control height text-area `}
                                placeholder={t('placeholder.riskAnalysis')}
                                disabled={disabled}
                                defaultValue={data.riskAnalysis}
                            />
                        </Col>
                        <Col xs={6} md={6} lg={3}>
                            <label className="label-measures">
                                {t('mitigation-measures.proposed')}
                            </label>
                            <TextArea
                                name="mitigationMeasures"
                                className="form-control text-area"
                                placeholder={t('placeholder.mitigationMeasures')}
                                disabled={disabled}
                                defaultValue={data.mitigationMeasures}
                            />
                            <label className="label-measures">
                                {t('mitigation-measures.charge-of-implementing')}
                            </label>
                            <SelectInfinite
                                api="/departments"
                                name="department"
                                labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                                className="select"
                                defaultValue={{
                                    value: data.departmentInChargeId, label: data.departmentInChargeName,
                                }}
                                isDisabled={true}
                                placeholder={t('placeholder.departments')}
                            />
                            <label className="label-measures">
                                {t('mitigation-measures.cost-estimation')}
                            </label>
                            <SelectInfinite
                                api="/cost-estimations"
                                name="cost"
                                labelKey="cost"
                                className="select"
                                defaultValue={{
                                    value: data.costEstimationId, label: data.costEstimationCost,
                                }}
                                isDisabled={disabled}
                                placeholder={t('placeholder.costEstimation')}
                                queryKeys={'cost.contains'}
                            />
                            <label className="label-measures">
                                {t('mitigation-measures.date')}
                            </label>
                            <InputDate
                                name="realizationDate"
                                isClearable
                                placeholderText={t('placeholder.pickDate')}
                                defaultValue={new Date(data.realizationDate)}
                                // selected={new Date(data.realizationDate)}
                                disabled={disabled}
                                isClearable={disabled ? false : true}
                            />
                        </Col>
                        <Col xs={6} md={6} lg={3}>
                            <label className="label-measures">
                                {t('mitigation-measures.result')}
                            </label>
                            <span
                                className="link-history"
                                onClick={(e) => toggleShowModal(e)}
                            >
                {t('mitigation-measures.history')}
              </span>
                            <TextArea
                                name="resultOfApplied"
                                className={`form-control height text-area `}
                                placeholder={t('placeholder.result')}
                                defaultValue={data.appliedMeasureResult?.name}
                                disabled={disabled}
                            />
                            <label className='label-measures'>
                                {t('mitigation-measures.IDHDRequest')}
                            </label>
                            <span className="optional register">{t('common.optional')}</span>
                            <InputText
                                type='string'
                                name='hdRequestId'
                                className='form-control input-field'
                                placeholder={t('placeholder.IDHDRequest')}
                                id='hdRequestId'
                                defaultValue={data.hdRequestId}
                                disabled={disabled}
                            />
                            <label className="label-measures">
                                {t('mitigation-measures.mitigation-percentage')}
                            </label>
                            <span className="optional register">{t('common.optional')}</span>
                            <InputText
                                type="number"
                                name="mitigationPercentage"
                                className="form-control input-field"
                                placeholder={t('placeholder.mitigationPercentage')}
                                defaultValue={data.mitigationPercentage}
                                disabled={disabled}
                                step=".01"
                                min="0"
                                onChange={onChangeMitigationPercentage}
                            />
                            <label className="label-measures">
                                {t('mitigation-measures.status')}
                            </label>
                            <SelectList
                                name="levelOfMeasureRealization"
                                className="select"
                                options={optionsTask}
                                defaultValue={{
                                    value: data.levelOfMeasureRealization,
                                    label: data.levelOfMeasureRealization === 'NOTSTARTED' ? t('mitigation-measures.notStarted') : data.levelOfMeasureRealization === 'INPROGRESS' ? t('mitigation-measures.inProgress') : t('mitigation-measures.realized'),
                                }}
                                placeholder={t('placeholder.levelOfMeasureRealization')}
                                isClearable={false}
                                isDisabled={disabled}
                            />
                        </Col>
                        <Col xs={6} md={6} lg={3}>
                            <label className="label-measures">
                                {t('mitigation-measures.reason')}
                            </label>
                            <TextArea
                                name="notStartedReason"
                                className="form-control text-area"
                                placeholder={t('placeholder.notStartedReason')}
                                disabled={disabled}
                                defaultValue={data.notStartedReason}
                            />
                        </Col>
                        <Col xs={6} md={6} lg={3}>
                            <label className="label-measures">
                                {t('mitigation-measures.loss-gross')}
                            </label>
                            <span className="optional register">{t('common.optional')}</span>
                            <InputText
                                type="number"
                                name="grossLoss"
                                className="form-control input-field"
                                placeholder={t('placeholder.lossGross')}
                                defaultValue={data.grossLoss}
                                disabled={true}
                                step=".01"
                                min="0"
                                onChange={onChangeGrossLoss}
                            />
                            <label className="label-measures">
                                {t('mitigation-measures.loss-collected')}
                            </label>
                            <span className="optional register">{t('common.optional')}</span>
                            <InputText
                                type="number"
                                name="lossChargedInsurance"
                                className="form-control input-field"
                                placeholder={t('placeholder.lossCollected')}
                                defaultValue={data.lossChargedInsurance}
                                disabled={disabled}
                                step=".01"
                                min="0"
                                onChange={onChangeLossChargedInsurance}
                            />
                            <label className="label-measures">
                                {t('mitigation-measures.loss-collected-other')}
                            </label>
                            <span className="optional register">{t('common.optional')}</span>
                            <InputText
                                type="number"
                                name="lossChargedOther"
                                className="form-control input-field"
                                defaultValue={data.lossChargedOther}
                                disabled={disabled}
                                placeholder={t('placeholder.lossCollectedOther')}
                                step=".01"
                                min="0"
                                onChange={onChangeLossChargedOther}
                            />
                            <label className="label-measures">
                                {t('mitigation-measures.loss-net')}
                            </label>
                            <span className="optional register">{t('common.optional')}</span>
                            <InputText
                                type="number"
                                name="netLoss"
                                className="form-control input-field"
                                placeholder={t('placeholder.lossNet')}
                                defaultValue={data.netLoss}
                                disabled={true}
                                step=".01"
                                min="0"
                                onChange={onChangeNetLoss}
                            />
                        </Col>
                        <Col xs={6} md={6} lg={3}>
                            <label className="label-measures">
                                {t('mitigation-measures.proposalAdditional')}
                            </label>
                            <span className="optional register">{t('common.optional')}</span>
                            <InputText
                                type="text"
                                name="additionalMitigationMeasures"
                                className="form-control input-field"
                                placeholder={t('placeholder.mitigationMeasuresAdditional')}
                                defaultValue={data.additionalMitigationMeasures}
                                disabled={disabled}
                            />
                            {!disabled ? (<>
                                    <label className="label-measures">
                                        {t('mitigation-measures.upload')}
                                    </label>
                                    <span className="optional register">
                    {t('common.optional')}
                  </span>
                                    <InputText
                                        id="upload"
                                        type="file"
                                        name="file"
                                        multiple
                                        className="file-input"
                                        onChange={uploadOnChange}
                                        disabled={disabled}
                                        accept={allowedFileTypes}
                                    />
                                    <ul className="mb-0" key={defaultFiles}>
                                        {defaultFiles?.map((file) => (<li key={file.id}>
                                                <div className="d-flex align-items-center">
                                                    <span className="mr-5">{file.fileName}</span>
                                                    {disabled ? (<DownloadOutlined
                                                            onClick={() => {
                                                                getMeasureFile(file.id, file.fileName);
                                                            }}
                                                        />) : (<img
                                                            src={Trash}
                                                            alt="trash"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                clearFetchedFile(file.id);
                                                            }}
                                                        />)}
                                                </div>
                                            </li>))}
                                    </ul>
                                    <div /* key={files} */>
                                        <ul>
                                            {files.map((file, index) => (<li key={file?.id}>
                                                    <div className="d-flex align-items-center">
                                                        <span className="mr-5">{file?.label}</span>
                                                        <img
                                                            src={Trash}
                                                            alt="trash"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                clearLocalFile(index);
                                                            }}
                                                        />
                                                    </div>
                                                </li>))}
                                        </ul>
                                    </div>
                                </>) : (<div>
                                    <div>
                                        <ul>
                                            {defaultFiles?.map((file) => (<li key={file.id}>
                                                    <div className="d-flex align-items-center">
                                                        <span className="mr-5">{file.fileName}</span>
                                                        <DownloadOutlined
                                                            onClick={() => {
                                                                getMeasureFile(file.id, file.fileName);
                                                            }}
                                                        />
                                                    </div>
                                                </li>))}
                                        </ul>
                                    </div>
                                </div>)}
                        </Col>
                    </Row>
                    <Row className="mb-3 pt-3 right-btns">
                        <Col lg={12} className="btns-float-right">
                            {userResponsibleRisk === userData.id && data.measureStatus !== 'VERIFIED' && (<button
                                    className="btn btn-primary btn-strong"
                                    onClick={(e) => toggleVerifyModal(e)}
                                >
                                    {t('buttons.verifyBtn')}
                                </button>)}
                            {allowEdit && disabled && data.measureStatus !== 'CLOSED' && (<button
                                    className="btn btn-primary btn-strong ml-2"
                                    onClick={(e) => setEdit(e)}
                                >
                                    {t('buttons.changeBtn')}
                                </button>)}

                            {disabled === false && (<>
                                    <button
                                        className="btn btn-cancel btn-strong"
                                        type="reset"
                                        onClick={handleCancel}
                                    >
                                        {t('buttons.cancelBtn')}
                                    </button>
                                    <button
                                        className="btn btn-primary btn-strong"
                                        disabled={disableBtn}
                                    >
                                        {t('buttons.saveBtn')}
                                    </button>
                                </>)}
                        </Col>
                    </Row>
                </form>
            </FormProvider>

            <ModalHistory
                data={data.id}
                open={isModalOpen}
                isOpen={(e) => setIsModalOpen(e)}
            />
            <ModalVerify
                open={isModalVerifyOpen}
                id={data.id}
                isOpen={(e) => setIsModalVerifyOpen(e)}
            />
        </>);
}

export default MeasuresFromShow;
